const Data = [
  {
    id: 1,
    category: "education",
    icon: "icon-graduation",
    year: "2018 - 2021",
    title: "Bachelor's Degree",
    desc: "Chaudhary Charan Singh University, Meerut",
  },
  {
    id: 2,
    category: "education",
    icon: "icon-graduation",
    year: "2013 - 2017",
    title: "Higher Secondary",
    desc: "Lal Dayal Public School, M. Nagar",
  },
  {
    id: 4,
    category: "experience",
    icon: "icon-briefcase",
    year: "2024 - present",
    title: "Sr. Software Engineer",
    desc: "Chetu Pvt. Ltd, Noida",
  },
  {
    id: 5,
    category: "experience",
    icon: "icon-briefcase",
    year: "2022 - 2024",
    title: "Jr. Software Engineer",
    desc: "Chetu Pvt. Ltd, Noida",
  },
];

export default Data;
